import {Message, MessageContent, MessageHeader} from "semantic-ui-react";
import {Link} from "react-router-dom";
import React from "react";

function StoresNotActiveWarning() {
    return<Message warning>
        <MessageHeader>Внимание</MessageHeader>
        <MessageContent>
            <p>Данный функционал для автозагрузки активен только с включенной опцией</p>
            <Link to={'/home'}>Выгружать товары со складов</Link>
        </MessageContent>
    </Message>
}

export default StoresNotActiveWarning;
